export default async function GetFilteredTopPlansApi(
  positionId,
  performanceCycle,
  title,
  planGroup,
  cascadeFrom,
  startAt,
  limit,
  sortOption
) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/filter?performanceCycle=${performanceCycle}&title=${title}&planGroup=${planGroup}&positionId=${positionId}&cascadeFrom=${cascadeFrom}&startAt=${startAt}&limit=${limit}&sortOption=${sortOption}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error getting top plan filter: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
